module.exports = __webpack_public_path__ + "p1_img1.jpg?4530f1159675d1363f74891d433a61f6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img1.jpg
// module id = 111
// module chunks = 0